import api from "./base-api"

const assistantApi = api.injectEndpoints({
    endpoints: (build) => ({
        getAssistantMessages: build.query({
            query: (game) => ({
                url: `v1/assistant/messages`,
                params: { game }
            }),
            providesTags: (result, error, game) => [{ type: "AssistantMessages", id: game }]
        }),
        sendAssistantChat: build.mutation({
            query: ({ game, message }) => ({
                url: `v1/assistant/chat`,
                method: "POST",
                params: { game },
                body: { message }
            }),
            invalidatesTags: (result, error, { game }) => [{ type: "AssistantMessages", id: game }]
        })
    }),
    overrideExisting: false
})

export const {
    useGetAssistantMessagesQuery,
    useSendAssistantChatMutation
} = assistantApi
